import { AxiosRequestConfig } from "axios";
import { Report } from "../../Interfaces/TableInterfaces";
import { DropdownItem } from "../../Interfaces/dropdownInterfaces";
import {
  IOrderFunctions,
  OrderTableSearchParam,
} from "../../Interfaces/orderInterfaces";
import { TradeTableReport } from "../../Interfaces/tradeTableInterfaces";
import { getRequest } from "../requestTemplates";

export const getTradeTable = async (
  searchParam: OrderTableSearchParam,
  offset: number | null,
  pageSize: number | null,
  factory: IOrderFunctions,
  sortingType: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<TradeTableReport>> =>
  factory.getTradeTable(searchParam, offset, pageSize, sortingType);

export const getBaseInstruments = async (
  callOption?: string | number
): Promise<Array<DropdownItem>> => {
  const urlSearchParam = new URLSearchParams();

  let url = "/v1/general/getBaseInstruments";
  if (callOption && callOption !== -1) {
    urlSearchParam.append("optionInsCode", callOption.toString());
    url += "?";
  }

  return getRequest(url + urlSearchParam.toString());
};
